import { Component, OnInit, HostListener } from '@angular/core';
import { AddfeesitemsService } from './addfeesitems.service';
import { SuperloginService } from '../superlogin/superlogin.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-addfeesitems',
  templateUrl: './addfeesitems.component.html',
  styleUrls: ['./addfeesitems.component.scss']
})
export class AddfeesitemsComponent implements OnInit {

  // ───────── FORM MODEL ─────────
  form = {
    label: '',
    amount: null as number | null,
    studentType: '',
    academicYear: '',
    semester: [] as string[]
  };

  // ───────── UI STATE ─────────
  loading = false;
  currentUser: any = null;

  constructor(
    private feeService: AddfeesitemsService,
    private authService: SuperloginService,
    private toastr: ToastrService
  ) {}

  // ───────── INIT ─────────
  ngOnInit(): void {
    if (!this.authService.isAuthenticated()) {
      this.authService.logout();
      return;
    }
    this.currentUser = this.authService.getCurrentUser();
  }

  // ───────── STUDENT TYPE (Single Select) ─────────
  studentDropdownOpen = false;

  studentTypes = [
    { label: 'Ghanaian', value: 'GHANAIAN' },
    { label: 'International', value: 'INTERNATIONAL' }
  ];

  selectedStudentType: any = null;

  toggleStudentDropdown() {
    this.studentDropdownOpen = !this.studentDropdownOpen;
    this.dropdownOpen = false;
    this.yearDropdownOpen = false;
  }

  selectStudentType(s: any) {
    this.selectedStudentType = s;
    this.form.studentType = s.value;
    this.studentDropdownOpen = false;
  }

  clearStudentType(event: Event) {
    event.stopPropagation();
    this.selectedStudentType = null;
    this.form.studentType = '';
  }

  // ───────── ACADEMIC YEAR (Single Select) ─────────
  yearDropdownOpen = false;

  academicYears = [
    { label: '2025/2026', value: '2025/2026' },
    { label: '2024/2025', value: '2024/2025' },
    { label: '2023/2024', value: '2023/2024' },
    { label: '2022/2023', value: '2022/2023' }
  ];

  selectedAcademicYear: any = null;

  toggleYearDropdown() {
    this.yearDropdownOpen = !this.yearDropdownOpen;
    this.dropdownOpen = false;
    this.studentDropdownOpen = false;
  }

  selectAcademicYear(y: any) {
    this.selectedAcademicYear = y;
    this.form.academicYear = y.value;
    this.yearDropdownOpen = false;
  }

  clearAcademicYear(event: Event) {
    event.stopPropagation();
    this.selectedAcademicYear = null;
    this.form.academicYear = '';
  }

  // ───────── SEMESTER (Multi Select UI → Single value sent) ─────────
  dropdownOpen = false;

  semesters = [
    { label: 'Semester 1', value: 'SEM1' },
    { label: 'Semester 2', value: 'SEM2' }
  ];

  selectedSemesters: any[] = [];

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    this.studentDropdownOpen = false;
    this.yearDropdownOpen = false;
  }

  toggleSemester(s: any) {
    const exists = this.selectedSemesters.find(x => x.value === s.value);

    if (exists) {
      this.selectedSemesters = this.selectedSemesters.filter(x => x.value !== s.value);
    } else {
      this.selectedSemesters.push(s);
    }

    this.form.semester = this.selectedSemesters.map(x => x.value);
  }

  removeSemester(s: any, event: Event) {
    event.stopPropagation();
    this.selectedSemesters = this.selectedSemesters.filter(x => x.value !== s.value);
    this.form.semester = this.selectedSemesters.map(x => x.value);
  }

  isSelected(s: any): boolean {
    return this.selectedSemesters.some(x => x.value === s.value);
  }

  // ───────── CLOSE DROPDOWNS ─────────
  @HostListener('document:click', ['$event'])
  handleOutside(event: any) {
    if (!event.target.closest('.fees-chip-select')) {
      this.dropdownOpen = false;
      this.studentDropdownOpen = false;
      this.yearDropdownOpen = false;
    }
  }

  // ───────── SUBMIT ─────────
  submitForm(): void {

    // Validation
    if (
      !this.form.label ||
      !this.form.amount ||
      !this.form.studentType ||
      !this.form.academicYear ||
      this.form.semester.length === 0
    ) {
      this.toastr.warning('Please fill all required fields.', 'Incomplete Form');
      return;
    }

    this.loading = true;

    const payload = {
      label: this.form.label,
      amount: Number(this.form.amount),
      studentType: this.form.studentType,
      academicYear: this.form.academicYear,
      semester: this.form.semester[0],
      createdBy: this.currentUser?.username || null
    };

    console.log('Submitting payload:', payload);

    this.feeService.addFeeItem(payload).subscribe({
      next: () => {
        this.loading = false;
        this.toastr.success('Fee item created successfully.', 'Success');
        this.resetForm();
      },

      error: (err) => {
        this.loading = false;

        const message = err.error?.message || err.message || 'Failed to create fee item.';
        this.toastr.error(message, 'Error');

        console.error('API Error:', err);
      }
    });
  }

  // ───────── RESET ─────────
  resetForm(): void {
    this.form = {
      label: '',
      amount: null,
      studentType: '',
      academicYear: '',
      semester: []
    };

    this.selectedSemesters = [];
    this.selectedStudentType = null;
    this.selectedAcademicYear = null;
  }
}